import {
    getParticipantById,
    getPinnedParticipant
} from '../../../../react/features/base/participants/functions';
import StateListenerRegistry from '../../../../react/features/base/redux/StateListenerRegistry';
import {
    wizyPinParticipant
} from '../../../wizyconf/components/large-video/actions';

/**
 * Subscribes to changes to the currently pinned participant in the user
 * interface of the local participant.
 */
StateListenerRegistry.register(
    /* selector */ state => {
        const pinnedParticipant = getPinnedParticipant(state);

        return pinnedParticipant ? pinnedParticipant.id : null;
    },
    /* listener */ (pinnedParticipant, { dispatch, getState }) => {
        const state = getState();

        if (!APP.wildix.wizy || !pinnedParticipant) {
            return;
        }
        const participant = getParticipantById(state, pinnedParticipant);
        const participantID = participant?.local ? 'localVideoContainer' : `participant_${pinnedParticipant}`;
        const targetNode = document.getElementById(participantID);

        if (targetNode?.classList?.contains('wizy-active')) {
            setTimeout(() => {
                targetNode.classList.add('wizy-active');
            }, 50);
            dispatch(wizyPinParticipant(true));
        }
    });
